import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { PropertyBuildingOption } from "../models/PropertyBuildingOption";

const paths = {
	index: "/property_building_options"
} as const;

type TIndex = (name: string) => SwrReturnType<PropertyBuildingOption[]>;

type ReturnType = {
	index: TIndex;
};

export const usePropertyBuildingOptions = (): ReturnType => {
	const index: TIndex = (name: string) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isValidating } = useSWR(
			name.length >= 2 ? { params: { name }, url: paths.index } : null
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			isValidating,
			mutate: mutate ?? null
		};
	};
	return { index };
};
